// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"carousel-slider-m__carousel-container__5fWxe","headline-container":"carousel-slider-m__headline-container__3f7dS"};